import React, { useEffect, useContext, useState, useRef, useMemo } from "react";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  getSystemSettings,
} from "../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Moment from "react-moment";
import moment from "moment";
import Select from "react-select";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import { useReactToPrint } from "react-to-print";

//pages & includes
import ReportSidebar from "./ReportSidebar";

//context consumer
import { SettingsContext } from "../../../../contexts/Settings";
import { RestaurantContext } from "../../../../contexts/Restaurant";
import CustomSpinLoader from "../../../components/CustomSpinLoader";

const StockIssuanceReport = () => {
  const { t } = useTranslation();
  // const history = useHistory();
  //getting context values here
  let {
    loading,
    setLoading,
    dataPaginating,
    setDataPaginating,
    generalSettings,
  } = useContext(SettingsContext);
  let { branchListWeb, branchForSearch } = useContext(RestaurantContext);

  //all data
  const [reportData, setReportData] = useState(null);
  const componentRef = useRef();
  const componentRef1 = useRef();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [issuanceReport, setIssuanceReport] = useState({
    reportType: "detail",
    from_branch: null,
    to_branch: null,
  });
  const [generatedReport, setGeneratedReport] = useState(false);
  const [siteName, setSiteName] = useState("");
  const [option, setOption] = useState("excel");

  useEffect(() => {
    setSiteName(getSystemSettings(generalSettings, "siteName"));
    
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [generalSettings]);

  const REPORT_TYPE_OPTIONS = useMemo(() => [
    { label: t("Summary Report"), value: "summary", name: "report_type" },
    { label: t("Detail Report"), value: "detail", name: "report_type" }
  ], []);

  const handleFromBranch = (fromBranch) => {
    setIssuanceReport({
      ...issuanceReport,
      from_branch: fromBranch,
      to_branch: null
    });
  };

  const handleToBranch = (toBranch) => {
    setIssuanceReport({
      ...issuanceReport,
      to_branch: toBranch,
    });
  };

  const handleOption = (e) => {
    setOption(e.target.value);
  };

  const handleChangeOptions = (type, value) => {
    setIssuanceReport((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  //get excel reports filter
  const getExcelReport = () => {
    setReportData(null);
    setGeneratedReport(false);
    if (startDate !== null && endDate !== null && issuanceReport.from_branch) {
      getReport();
    } else {
      toast.error(
        `${_t(t("Please select from date, to date, branch"))}`,
        {
          position: "bottom-center",
          closeButton: false,
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        }
      );
    }
  };

  const getReport = async () => {
    setDataPaginating(true);
    const fromDate = moment(startDate).format("YYYY-MM-DD");
    const toDate = moment(endDate).format("YYYY-MM-DD");
    const url = BASE_URL + "/settings/stock-issuance-report";
    let formData = new FormData();
    formData.append("fromDate", fromDate);
    formData.append("toDate", toDate);
    formData.append("fromBranch", issuanceReport.from_branch ? issuanceReport.from_branch.id : "");
    formData.append("toBranch", issuanceReport.to_branch ? issuanceReport.to_branch?.id : "");
    formData.append("type", issuanceReport.reportType);

    return axios
      .post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        console.log("ReportResult", res);
        setGeneratedReport(true);
        setReportData(res.data);
        setDataPaginating(false);
        if(issuanceReport.reportType === "summary"){
          componentRef1.current.handleDownload();
        }else{
          componentRef.current.handleDownload();
        }
      })
      .catch((error) => {
        setDataPaginating(false);
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          closeButton: false,
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  };

  return (
    <>
      <Helmet>
        <title>{_t(t("Stock Issuance Report"))}</title>
      </Helmet>
      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-to-xls"
        filename="Stock Issuance Detail"
        sheet="sheet 1"
        buttonText="Stock Issuance Detail"
        ref={componentRef}
      />

      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-to-xls1"
        filename="Stock Issuance Summary"
        sheet="sheet 1"
        buttonText="Stock Issuance Summary"
        ref={componentRef1}
      />

      {/* Excel Report Details*/}
      <div className="d-none">
        <div>
          <div className="fk-print">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  {reportData !== null &&
                    reportData !== undefined &&
                    generatedReport === true && (
                      <>
                        <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                          <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                            <table
                              className="table table-bordered table-hover min-table-height mt-3"
                              id="table-to-xls"
                            >
                              <div className="page-break"></div>
                              <thead className="align-middle">
                                <tr style={{ border: "0px" }}>
                                  <th colspan="11" style={{ border: "0px" }}>
                                    <div className="row">
                                      <div className="col-12">
                                        <h3 className="text-center mb-0">
                                          {siteName}
                                        </h3>
                                        <h3 className="text-center mt-0">
                                          Stock Issuance Report
                                        </h3>
                                        <p className="text-center">
                                          FROM&nbsp;
                                          <Moment format="LL">
                                            {startDate}
                                          </Moment>
                                          &nbsp;TO&nbsp;
                                          <Moment format="LL">{endDate}</Moment>
                                        </p>
                                      </div>
                                    </div>
                                  </th>
                                </tr>
                                <tr>
                                  <th scope="col">{_t(t("Document Id"))}</th>
                                  <th scope="col">{_t(t("Document Date"))}</th>
                                  <th scope="col">{_t(t("Doc Ref Id"))}</th>
                                  <th scope="col">{_t(t("From Branch"))}</th>
                                  <th scope="col">{_t(t("To Branch"))}</th>
                                  <th scope="col">{_t(t("Item Name"))}</th>
                                  <th scope="col">{_t(t("Qty"))}</th>
                                  <th scope="col">{_t(t("Stock Qty"))}</th>
                                  <th scope="col">{_t(t("Unit"))}</th>
                                  <th scope="col">{_t(t("Cost Price"))}</th>
                                  <th scope="col">{_t(t("Remarks"))}</th>
                                </tr>
                              </thead>
                              <tbody className="align-middle">
                                {/* {console.log("309 ", reportData)} */}
                                {/* loop here*/}
                                {reportData?.length &&
                                  reportData.map((item, index) => {
                                    let totalQty = 0;
                                    return (
                                      <>
                                        <tr key={index}>
                                          <td scope="row">
                                            {item.document_identity}
                                          </td>
                                          <td scope="row">
                                            <Moment format="LL">
                                              {item.document_date}
                                            </Moment>
                                          </td>
                                          <td scope="row">
                                            {item.ref_identity}
                                          </td>
                                          <td scope="row">
                                            {item.from_branch_name}
                                          </td>
                                          <td scope="row">
                                            {item.to_branch_name}
                                          </td>
                                          <td scope="row">
                                            {item.item_name}
                                          </td>
                                          <td scope="row">
                                            {item.qty}
                                          </td>
                                          <td scope="row">
                                            {item.stock_qty}
                                          </td>
                                          <td scope="row">
                                            {item.unit_name}
                                          </td>
                                          <td scope="row">
                                            {item.cost_price}
                                          </td>
                                          <td scope="row">{item.remarks}</td>
                                        </tr>
                                      </>
                                    );
                                  })}
                              </tbody>

                              <tfoot style={{ border: "0px" }}>
                                <tr style={{ border: "0px" }}>
                                  <td
                                    colspan="7"
                                    className="text-center"
                                    style={{ border: "0px" }}
                                  >
                                    <h5 className="mt-3">
                                      Powered by indolj.pk
                                    </h5>
                                  </td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>
                      </>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

       {/* Excel Report Details*/}
       <div className="d-none">
        <div>
          <div className="fk-print">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  {reportData !== null &&
                    reportData !== undefined &&
                    generatedReport === true && (
                      <>
                        <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                          <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                            <table
                              className="table table-bordered table-hover min-table-height mt-3"
                              id="table-to-xls1"
                            >
                              <div className="page-break"></div>
                              <thead className="align-middle">
                                <tr style={{ border: "0px" }}>
                                  <th colspan="6" style={{ border: "0px" }}>
                                    <div className="row">
                                      <div className="col-12">
                                        <h3 className="text-center mb-0">
                                          {siteName}
                                        </h3>
                                        <h3 className="text-center mt-0">
                                          Stock Transfer Report
                                        </h3>
                                        <p className="text-center">
                                          FROM&nbsp;
                                          <Moment format="LL">
                                            {startDate}
                                          </Moment>
                                          &nbsp;TO&nbsp;
                                          <Moment format="LL">{endDate}</Moment>
                                        </p>
                                      </div>
                                    </div>
                                  </th>
                                </tr>
                                <tr>
                                  <th scope="col">{_t(t("Document Id"))}</th>
                                  <th scope="col">{_t(t("Document Date"))}</th>
                                  <th scope="col">{_t(t("Doc Ref Id"))}</th>
                                  <th scope="col">{_t(t("From Branch"))}</th>
                                  <th scope="col">{_t(t("To Branch"))}</th>
                                  <th scope="col">{_t(t("Remarks"))}</th>
                                </tr>
                              </thead>
                              <tbody className="align-middle">
                                {/* {console.log("309 ", reportData)} */}
                                {/* loop here*/}
                                {reportData?.length &&
                                  reportData.map((item, index) => {
                                    let totalQty = 0;
                                    return (
                                      <>
                                        <tr key={index}>
                                          <td scope="row">
                                            {item.document_identity}
                                          </td>
                                          <td scope="row">
                                            <Moment format="LL">
                                              {item.document_date}
                                            </Moment>
                                          </td>
                                          <td scope="row">
                                            {item.ref_identity}
                                          </td>
                                          <td scope="row">
                                            {item.from_branch_name}
                                          </td>
                                          <td scope="row">
                                            {item.to_branch_name}
                                          </td>
                                          <td scope="row">{item.remarks}</td>
                                        </tr>
                                      </>
                                    );
                                  })}
                              </tbody>

                              <tfoot style={{ border: "0px" }}>
                                <tr style={{ border: "0px" }}>
                                  <td
                                    colspan="7"
                                    className="text-center"
                                    style={{ border: "0px" }}
                                  >
                                    <h5 className="mt-3">
                                      Powered by indolj.pk
                                    </h5>
                                  </td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>
                      </>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ReportSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    <CustomSpinLoader loading={loading}/>

                    {/* spin loading ends */}

                    {/* Loading effect {loading === true ? (
                        tableLoading()
                      ) : ( */}

                    <div key="smtp-form">
                      <div className="gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="row t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb col-6">
                            <li className="fk-breadcrumb__list">
                              <span className="pl-3 t-link fk-breadcrumb__link text-capitalize">
                                {_t(t("Stock Issuance Report"))}
                              </span>
                            </li>
                          </ul>
                          <div className="col-6 d-flex justify-content-end p-0">

                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-2 d-md-block">
                          <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control"
                            placeholderText={_t(t("From date"))}
                            shouldCloseOnSelect={false}
                          />
                        </div>

                        <div className="col-md-2 d-md-block">
                          <DatePicker
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control"
                            placeholderText={_t(t("To date"))}
                            shouldCloseOnSelect={false}
                          />
                        </div>

                        <div className="col-2">
                          <Select
                            options={branchForSearch ? branchForSearch : []}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={issuanceReport.from_branch}
                            classNamePrefix="select"
                            className="table-text"
                            onChange={handleFromBranch}
                            maxMenuHeight="200px"
                            placeholder={_t(t("From branch")) + ".."}
                          />
                        </div>

                        <div className="col-2">
                          <Select
                            options={branchListWeb ? branchListWeb.filter((item)=>item.id!== issuanceReport?.from_branch?.id) : []}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={issuanceReport.to_branch}
                            classNamePrefix="select"
                            className="table-text"
                            onChange={handleToBranch}
                            maxMenuHeight="200px"
                            placeholder={_t(t("To branch")) + ".."}
                          />
                        </div>

                        <div className="col-2 d-flex flex-wrap">
                          {REPORT_TYPE_OPTIONS.map((opt, index) => (
                            <div
                              key={opt.value}
                              className={`d-inline d-flex align-items-center mr-1`}
                            >
                              <input
                                type="radio"
                                id={opt.value}
                                name={opt.name}
                                value={opt.value}
                                checked={issuanceReport?.reportType === opt.value}
                                onChange={() => handleChangeOptions("reportType", opt.value)}
                                className="form-check-input pointer-cursor"
                              />
                              <label
                                htmlFor={opt.value}
                                style={{ fontSize: "16px", borderRadius: "5px" }}
                                className="form-radio-label pointer-cursor ml-2 pt-1 text-primary"
                              >
                                {opt.label}
                              </label>
                            </div>
                          ))}
                        </div>

                        <div className="col-2 t-mb-15 mb-md-0 text-right">
                          <button
                            className="ml-1 btn btn-block btn-primary sm-text py-2 rounded"
                            onClick={(e) => getExcelReport()}
                          >
                            GENERATE REPORT
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
    </>
  );
};

export default StockIssuanceReport;
